import { Loader2 } from 'lucide-react'

export default function LoadingSpinner() {
  return (
    <div className="flex justify-center items-center min-h-[200px]">
      <Loader2 className="w-8 h-8 text-primary-500 animate-spin" />
    </div>
  )
}
